import AuthLayout from "../AuthLayout";
import mobileIcon from "../../../assets/img/mobile-alt.svg";
import {Spinner} from "react-bootstrap";
import {useState} from "react";
import api from '../../../shared/utils/auth/Index';
import {storeAuthToken} from "../../../shared/utils/auth/authToken";
import {useAlert} from "react-alert";

const EnterCode = ({mobile}) => {
    let reactAlert = useAlert();

    const [code, setCode] = useState('');
    const [sending, setSending] = useState(false);

    const onSubmit = (e) => {
        e.preventDefault();
        setSending(true);

        let url = '/general/forgot/verify-code';
        api.post(url, {mobile: mobile, code: code}, (res) => {
            let data = res.data.data;
            storeAuthToken(data.access_token)
            redirect();
        }, (err) => {
            setSending(false);
            let data = err.data;
            reactAlert.error(data.message);
        });
    }

    const redirect = () => {
        let getUrl = window.location;
        let baseUrl = getUrl.protocol + "//" + getUrl.host;
        window.location.replace(baseUrl);
    }

    return (
        <AuthLayout>
            <form onSubmit={(e) => onSubmit(e)}>

                <div className="row">
                    <div className="col-auto mx-auto">
                        <img src="/logo.png" alt="Logo" className="img-fluid"/>
                    </div>
                </div>

                <div className="row font-irs-b mt-5">
                    <div className="col-auto mx-auto">
                        <div className="row">
                            <div className="col-12 pr-4">
                                کد فعال سازی به شماره { mobile } فرستاده شد.
                            </div>
                        </div>

                        <div className="row align-items-center">
                            <div className="col pl-0">
                                <input type="text"
                                       value={code}
                                       onChange={(e) => setCode(e.target.value)}
                                       className="auth-input" required
                                        placeholder="کد فعالسازی را وارد کنید"/>
                            </div>
                            <div className="col-auto px-0">
                                <div className="auth-icon">
                                    <img src={mobileIcon} className="img-fluid"/>
                                </div>
                            </div>
                        </div>

                        <div className="row align-items-center mt-4">
                            <div className="col-auto mr-auto pl-0">
                                <button className="btn auth-btn font-irs-b">تائید
                                    {sending && <Spinner animation="border"/>}
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        </AuthLayout>
    )
};

export default EnterCode;
